document.addEventListener("DOMContentLoaded", () => {
  const thumbsUpBtn = document.querySelector('button.up')
  const thumbsDownBtn = document.querySelector('button.down')
  const thumbsSendBtn = document.querySelector('button.send')

  var messageContainer = document.querySelector('.thumbs-message-container')
  var buttonContainer = document.querySelector('.thumbs-button-container')

  const thumbValue = document.querySelector('.thumb-input')
  const pageValue = document.querySelector('.page-input')
  const messageValue = document.querySelector('.message-input')

  if (thumbsUpBtn) {
    thumbsUpBtn.addEventListener('click', function () {
      thumbValue.value = 'up'
      pageValue.value = window.location.pathname
      messageContainer.classList.toggle('show')
      buttonContainer.classList.toggle('show')

      gtag('event', '_sendThumb', {
        'event_label': 'thumbs',
        'value': 'up'
      });

    })
    thumbsDownBtn.addEventListener('click', function () {
      thumbValue.value = 'down'
      pageValue.value = window.location.pathname
      messageContainer.classList.toggle('show')
      buttonContainer.classList.toggle('show')

      gtag('event', '_sendThumb', {
        'event_label': 'thumbs',
        'value': 'down'
      });

    })
    thumbsSendBtn.addEventListener('click', function () {
      sendThumb()
    })
  }
})

function sendThumb() {
  var messageContainer = document.querySelector('.thumbs-message-container')
  var responseContainer = document.querySelector('.thumbs-response-container')
  const form = document.querySelector('#thumbsForm')

  grecaptcha.ready(function () {
    grecaptcha.execute('6Lfa2P8UAAAAABC6DlDHvyzoW7xhzeCgb5zoPaY4', { action: 'submit' }).then(function (token) {
      form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="g-recaptcha-response" value="${token}" />`);

     

      const formData = new FormData(form)

      var object = {};
      formData.forEach((value, key) => object[key] = value);

      const headers = new Headers({
        "Content-Type": "application/json"
      })
      const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(object)
      }

      fetch(form.action, options)
        .then(res => res.json())
        .then(res => {
          if (res.success) {
            responseContainer.classList.toggle('show')
            messageContainer.classList.toggle('show')
          } else {
            console.error(res.reason)
          }
        })
      return false;
    });
  });
}